import ImageBig from './imageBig'
import ImageSmall from './imageSmall'

const ImageGroup = ({ imageSmall, imageBig }) => {
  const base =
    'order-1 lg:order-2 flex flex-col lg:flex-row items-start justify-end grow min-w-0 gap-[30px] md:gap-[40px]'
  return (
    <div className={base}>
      {imageSmall && <ImageSmall image={imageSmall} />}
      <ImageBig image={imageBig} />
    </div>
  )
}

export default ImageGroup
